// extracted by mini-css-extract-plugin
module.exports = {"content-benefits-wrapper":"ContentBenefits_content-benefits-wrapper__8RxVV"};